var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.33464 13.8337C2.41797 13.8337 1.66797 13.0837 1.66797 12.167V3.83366C1.66797 2.91699 2.41797 2.16699 3.33464 2.16699H11.668C12.5846 2.16699 13.3346 2.91699 13.3346 3.83366M8.33464 7.16699H16.668C17.5884 7.16699 18.3346 7.91318 18.3346 8.83366V17.167C18.3346 18.0875 17.5884 18.8337 16.668 18.8337H8.33464C7.41416 18.8337 6.66797 18.0875 6.66797 17.167V8.83366C6.66797 7.91318 7.41416 7.16699 8.33464 7.16699Z","stroke":"#262AC5","strokeWidth":"1.66667","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Copy.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = Copy;

Copy.default = Copy;
